module.exports = __webpack_public_path__ + "static/img/icoan_dabiao@2x.618bdfd3.png";